import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var LightningOutlineSVG = function LightningOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    d: "M13.7 30a1.434 1.434 0 0 1-1.42-1.61l.99-8.66H8.1c-.54 0-1.03-.3-1.27-.79-.24-.47-.2-1.04.1-1.48l10.2-14.84c.38-.55 1.07-.77 1.69-.52.61.24.98.86.9 1.51l-.99 8.66h5.17c.54 0 1.03.3 1.27.79.24.47.2 1.04-.1 1.48L14.86 29.39c-.27.4-.71.62-1.17.62l.01-.01zM8.92 17.87h4.88c.4 0 .78.17 1.05.47.26.3.39.69.35 1.09l-.85 7.45 8.75-12.73h-4.88c-.4 0-.78-.17-1.05-.47-.26-.3-.39-.69-.35-1.09l.85-7.45-8.75 12.73z",
    stroke: "none"
  }));
};
LightningOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(LightningOutlineSVG);